module.exports = __webpack_public_path__ + "static/logos/google-g-logo-edd0e34f60d7ca4a2f4ece79cff21ae3.svg";